import React from 'react';

/**
 * The one button in the app.
 *
 * variant: primary | secondary | outline | ghost | link | danger
 * size:    sm | md | lg
 * Handles disabled + loading states consistently (a loading button is
 * inert, so a form cannot be submitted twice).
 */
const Button = React.forwardRef(function Button(
  {
    variant = 'outline',
    size = 'md',
    block = false,
    loading = false,
    loadingText,
    disabled = false,
    type = 'button',
    className = '',
    children,
    ...rest
  },
  ref
) {
  const classes = [
    'ij-btn',
    `ij-btn--${variant}`,
    size !== 'md' ? `ij-btn--${size}` : '',
    block ? 'ij-btn--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <span className="ij-btn__spinner" aria-hidden="true" />}
      {loading ? loadingText || children : children}
    </button>
  );
});

export default Button;
